import { render, staticRenderFns } from "./ClaimCreateDrawer.vue?vue&type=template&id=934c5372"
import script from "./ClaimCreateDrawer.vue?vue&type=script&lang=js"
export * from "./ClaimCreateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports